<template>
  <div style="height: 99%">
    <div class="headCard">
      <el-card style="height: 65px" class="box-card">
        <div slot="header" class="FCC">
          <div class="FC">
            <span class="CH_FontSty">复杂工艺配置</span>
          </div>
          <div class="FC" style="margin-right: 32px">
            <el-button
              type="primary"
              size="small"
              @click="InserworkmansVisible = true"
              >添加展示</el-button
            >
          </div>
        </div>
      </el-card>
    </div>
    <div class="contentCard">
      <el-row>
        <el-col :span="4" :offset="0">
          <el-card
            class="box-card"
            style="width: 100%; height: 77vh; overflow: auto"
          >
            <el-button
              type="primary"
              size="small"
              style="margin-top: 15px"
              @click="getComplexList('all')"
              >显示全部</el-button
            >
            <zTree
              v-if="zNodes.length"
              :zNodes="zNodes"
              @getData="getComplexList"
              @addZtree="addZtree"
              @delZtree="delZtree"
              @EditName="EditName"
              @dropTree="dropTree"
              :changeInit="true"
              :options="{
                id: 'cpcf01',
                pid: 'cpcf08',
                label: 'cpcf03',
                zTreeId: 'complexTree',
                delType: {
                  add: true,
                  update: true,
                  del: true,
                },
              }"
              ref="zTree"
            />
          </el-card>
        </el-col>
        <el-col :span="20" :offset="0" style="height: 79vh; overflow: auto">
          <el-card
            v-for="(item, index) in tableData"
            :key="index"
            class="box-card"
            style="width: 31.9%"
          >
            <div slot="header" class="FCC">
              <div class="FC">
                <img src="@/assets/img/Prefabricated/icon_title.svg" alt="" />
                <span class="CH_FontSty">{{ item.cpcf03 }}</span>
              </div>
              <div class="FC" style="margin-right: 32px">
                <el-button type="text" @click="EditComp(item)">
                  <img
                    src="@/assets/img/projectFront/edit.png"
                    style="width: 17px; height: 18px"
                  />
                </el-button>
                <el-button type="text" @click="delComp(item.cpcf01)">
                  <img
                    src="@/assets/img/projectFront/del.png"
                    style="width: 17px; height: 18px; margin-left: 10px"
                  />
                </el-button>
              </div>
            </div>
            <el-row>
              <el-col :span="24">
                <el-tooltip
                  v-if="item.cpcf06"
                  class="item"
                  effect="dark"
                  placement="right"
                >
                  <div slot="content">
                    <p class="mytt">{{ item.cpcf06 }}</p>
                  </div>
                  <div v-if="item.cpcf04 == 1" class="col-Img">
                    <el-image
                      class="imgage"
                      :src="$store.state.baseUrl + item.cpcf10"
                      alt=""
                      :preview-src-list="item.cpcf05"
                    >
                    </el-image>
                  </div>
                  <div v-if="item.cpcf04 == 2" class="col-video">
                    <video
                      class="video"
                      :src="$store.state.baseUrl + item.cpcf10"
                      controls="controls"
                    ></video>
                    <div class="delete-img">
                      <el-button
                        type="primary"
                        class="dangBut"
                        @click="switchVid(item)"
                        >切换视频</el-button
                      >
                    </div>
                  </div>
                </el-tooltip>
                <div v-else>
                  <div v-if="item.cpcf04 == 1" class="col-Img">
                    <el-image
                      class="imgage"
                      :src="$store.state.baseUrl + item.cpcf10"
                      alt=""
                      :preview-src-list="item.cpcf05"
                    >
                    </el-image>
                  </div>
                  <div v-if="item.cpcf04 == 2" class="col-video">
                    <video
                      class="video"
                      :src="$store.state.baseUrl + item.cpcf10"
                      controls="controls"
                    ></video>
                    <div class="delete-img">
                      <el-button
                        type="primary"
                        class="dangBut"
                        @click="switchVid(item)"
                        >切换视频</el-button
                      >
                    </div>
                  </div>
                </div>
              </el-col>
              <!-- <el-col :span="10" style="padding-left: 10px">
                <p class="mytt">
                  {{ item.cpcf06 }}
                </p>
              </el-col> -->
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <!-- 添加工艺 -->
    <el-dialog
      title="添加工艺"
      :visible.sync="InserworkmansVisible"
      width="30%"
    >
      <el-form ref="uploadForm" :model="FileFrom" label-width="100px">
        <el-form-item
          ><h4 v-if="addfid">
            * 已选中[{{ addfid.cpcf03 }}]根节点
          </h4></el-form-item
        >
        <el-form-item label="工艺标题">
          <el-input
            style="width: 360px"
            v-model="FileFrom.WorkmanName"
            placeholder="请输入工艺"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="上传类型">
          <el-radio-group v-model="FileFrom.WorkmanType">
            <el-radio label="1">图片</el-radio>
            <el-radio label="2">视频</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-show="FileFrom.WorkmanType == 1">
          <el-form-item label="展示文件" class="formUpload">
            <el-upload
              class="upload-demo"
              action="#"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :on-change="handleChange"
              :file-list="FileFrom.fileListImg"
              :auto-upload="false"
              list-type="picture"
              multiple
              accept=".jpg,.jpeg,.png,.JPG,.JPEG"
            >
              <el-button size="small" type="primary">选取文件</el-button>
              <el-button
                v-if="FileFrom.fileListImg.length > 0"
                size="small"
                @click.stop="imgsort('add')"
                type="primary"
                plain
                >调整顺序</el-button
              >
            </el-upload>
          </el-form-item>
        </div>
        <div v-show="FileFrom.WorkmanType == 2">
          <el-form-item label="展示文件" class="formUpload">
            <el-upload
              class="upload-demo"
              action="#"
              drag
              :limit="1"
              :on-change="handleChangeVideo"
              :auto-upload="false"
              :file-list="FileFrom.fileListVideo"
              accept=".mp4,.mkv,.MP4,.MKV"
            >
              <div class="el-upload__text" style="margin-top: 15%">
                <em>点击上传</em>&nbsp;&nbsp; / &nbsp;&nbsp;拖拽到此区域
              </div>
              <div
                style="margin-top: 5%; color: #cfd2d8"
                class="el-upload__tip"
              >
                支持MP4、MKV格式
              </div>
            </el-upload>
          </el-form-item>
        </div>
        <el-form-item label="工艺描述">
          <el-input
            style="width: 360px"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-model="FileFrom.WorkmanDesc"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="InserworkmansVisible = false">取 消</el-button>
        <el-button type="primary" @click="InsertWorkmandeter('uploadForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 编辑工艺 -->
    <el-dialog title="编辑工艺" :visible.sync="EditworkmansVisible" width="30%">
      <el-form ref="EdituploadForm" :model="EditFileFrom" label-width="100px">
        <el-form-item label="工艺标题">
          <el-input
            style="width: 360px"
            v-model="EditFileFrom.cpcf03"
            placeholder="请输入工艺"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="上传类型">
          <el-radio-group v-model="EditFileFrom.cpcf04">
            <el-radio :label="1">图片</el-radio>
            <el-radio :label="2">视频</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-show="EditFileFrom.cpcf04 == 1">
          <el-form-item label="展示文件" class="formUpload">
            <el-upload
              class="upload-demo"
              action="#"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :on-change="handleChange"
              :file-list="EfileListImg"
              list-type="picture"
              multiple
              :auto-upload="false"
              accept=".jpg,.jpeg,.png,.JPG,.JPEG"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <el-button
                v-if="EfileListImg.length > 0"
                size="small"
                @click.stop="imgsort('update')"
                type="primary"
                plain
                >调整顺序</el-button
              >
            </el-upload>
          </el-form-item>
        </div>
        <div v-show="EditFileFrom.cpcf04 == 2">
          <el-form-item label="展示文件" class="formUpload">
            <el-upload
              class="upload-demo"
              action="#"
              drag
              :limit="1"
              :auto-upload="false"
              :on-change="handleChangeVideo"
              :file-list="EfileListVideo"
              accept=".mp4,.mkv,.MP4,.MKV"
            >
              <div class="el-upload__text" style="margin-top: 15%">
                <em>点击上传</em>&nbsp;&nbsp; / &nbsp;&nbsp;拖拽到此区域
              </div>
              <div
                style="margin-top: 5%; color: #cfd2d8"
                class="el-upload__tip"
              >
                支持MP4、MKV格式
              </div>
            </el-upload>
          </el-form-item>
        </div>
        <el-form-item label="工艺描述">
          <el-input
            style="width: 360px"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-model="EditFileFrom.cpcf06"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="EditworkmansVisible = false">取 消</el-button>
        <el-button type="primary" @click="EditWorkmandeter('EdituploadForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 更换视频 -->
    <el-dialog title="更换视频" :visible.sync="ResetDialogVisible" width="30%">
      <el-form ref="form" :model="switchFileFrom" label-width="100px">
        <div v-show="switchFileFrom.cpcf04 == 1">
          <el-form-item label="展示文件" class="formUpload">
            <el-upload
              class="upload-demo"
              action="#"
              drag
              multiple
              :on-change="handleChange"
              :auto-upload="false"
              :file-list="SfileListImg"
              accept=".jpg,.jpeg,.png,.JPG,.JPEG"
            >
              <div class="el-upload__text" style="margin-top: 15%">
                <em>点击上传</em>&nbsp;&nbsp; / &nbsp;&nbsp;拖拽到此区域
              </div>
              <div
                style="margin-top: 5%; color: #cfd2d8"
                class="el-upload__tip"
              >
                为保证最佳显示效果，请上传16:9比例的文件
              </div>
            </el-upload>
          </el-form-item>
        </div>
        <div v-show="switchFileFrom.cpcf04 == 2">
          <el-form-item label="展示文件" class="formUpload">
            <el-upload
              class="upload-demo"
              action="#"
              drag
              :limit="1"
              :on-change="handleChangeVideo"
              :auto-upload="false"
              :file-list="SfileListVideo"
              accept=".mp4,.mkv,.MP4,.MKV"
            >
              <div class="el-upload__text" style="margin-top: 15%">
                <em>点击上传</em>&nbsp;&nbsp; / &nbsp;&nbsp;拖拽到此区域
              </div>
              <div
                style="margin-top: 5%; color: #cfd2d8"
                class="el-upload__tip"
              >
                支持MP4、MKV格式
              </div>
            </el-upload>
          </el-form-item>
        </div>
        <div style="margin-top: 2%; color: #cfd2d8; margin-left: 100px">
          上传后将会覆盖替换原有文件！
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ResetDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="resetSubmit()">上 传</el-button>
      </span>
    </el-dialog>
    <!-- 调整顺序 -->
    <el-dialog title="调整顺序" :visible.sync="DialogVisibleSort" width="25%">
      <ul class="el-upload-list el-upload-list--picture">
        <li
          tabindex="0"
          v-for="(item, index) in sortImgs"
          :key="index"
          class="el-upload-list__item is-ready"
          style=""
        >
          <img
            :src="item.url"
            alt=""
            class="el-upload-list__item-thumbnail"
          /><a class="el-upload-list__item-name"
            ><i class="el-icon-document"></i>{{ item.name }}
            <el-input
              style="width: 40%; float: right"
              v-model="item.sortnum"
              placeholder="请输入序号"
              type="number"
              min="1"
              :max="sortImgs.length"
            ></el-input>
          </a>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogVisibleSort = false">取 消</el-button>
        <el-button type="primary" @click="submitMove()">确定</el-button>
      </span>
    </el-dialog>

    <!-- 目录编辑 -->
    <el-dialog title="目录编辑" :visible.sync="InsertScenVisible2" width="30%">
      <el-form ref="Form" label-width="80px">
        <el-form-item label="目录名称">
          <el-input
            style="width: 400px"
            v-model="appliName2"
            placeholder="请输入节点名称"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="工艺工序" v-if="mltype === 'add'">
          <el-select
            style="width: 400px"
            v-model="appliModel2"
            multiple
            filterable
            placeholder="请选择目录"
          >
            <el-option
              v-for="(item, index) in tableData"
              :key="index"
              :label="item.cpcf03"
              :value="item.cpcf01"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="InsertScenVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="InsertScendeter2()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetComplexcraftsList,
  InsertComplexcraft,
  DeleteComplexcraft,
  UpdateComplexcraft,
  ChangeFormTempTreeOrderFroComplexcraft,
  UpdateComplexcraftName,
} from "@/setAxios";
import zTree from "@/components/zTree";
export default {
  components: { zTree },
  data() {
    return {
      zNodes: [],
      tableData: [],
      pageIndex: 1,
      pageSize: 999999,
      total: 0,
      InserworkmansVisible: false,
      FileFrom: {
        WorkmanName: "",
        WorkmanType: "1",
        WorkmanDesc: "",
        fileListImg: [], //图片
        fileListVideo: [], //视频
      },
      UploadFileFrom: new FormData(),
      EUploadFileFrom: new FormData(),
      UploadFileFrom2: new FormData(),
      EditworkmansVisible: false,
      EditFileFrom: {}, //修改复杂工艺
      EfileListImg: [], //修改复杂工艺图片
      imageUrl: [],
      EfileListVideo: [], //修改复杂工艺视频
      ResetDialogVisible: false, //更换视频
      switchFileFrom: {},
      SfileListVideo: [],
      SfileListImg: [],
      srcList: [], //大图
      images: [
        "https://fastly.jsdelivr.net/npm/@vant/assets/apple-1.jpeg",
        "https://fastly.jsdelivr.net/npm/@vant/assets/apple-2.jpeg",
      ],
      delUrl: [],
      sortImgs: [],
      DialogVisibleSort: false,
      updateUrl: [],
      type: "",
      newurl: "",
      InsertScenVisible2: false,
      appliIdl2: "",
      appliName2: "",
      appliModel2: "",
      mltype: "",
      mlpid: 0,
      mlids: [],
      addfid: "",
    };
  },
  methods: {
    async addZtree(id) {
      this.mlpid = id;
      this.mltype = "add";
      this.InsertScenVisible2 = true;
    },
    delZtree(id) {
      this.delComp({ cpcf01: id, pass: true });
    },
    EditName(row) {
      this.appliIdl2 = row.cpcf01;
      this.appliName2 = row.cpcf03;
      var arrch = [];
      if (row.children) {
        row.children.forEach((e) => {
          arrch.push(e.cpcf01);
        });
        this.$set(this, "appliModel2", arrch);
      }
      this.mltype = "update";
      this.InsertScenVisible2 = true;
    },
    //排序
    async dropTree(data) {
      let res = await ChangeFormTempTreeOrderFroComplexcraft(data);
      if (res.Code) this.$message.success("修改成功");
    },
    //确定
    async InsertScendeter2() {
      if (this.appliName2 == "") {
        this.$message({
          type: "error",
          message: "请完成选项!",
        });
        return;
      } else {
        if (this.mltype == "add") {
          this.UploadFileFrom = new FormData();
          this.UploadFileFrom.append("pid", this.$store.state.xid);
          this.UploadFileFrom.append("title", this.appliName2);
          this.UploadFileFrom.append("type", 0);
          this.UploadFileFrom.append("files", "");
          this.UploadFileFrom.append("describe", "");
          this.UploadFileFrom.append("fid", 0);
          this.UploadFileFrom.append("sort", 0);
          this.UploadFileFrom.append("ids", this.appliModel2.join(","));
          let res = await InsertComplexcraft(this.UploadFileFrom);
          if (res.Code) {
            this.$message({
              type: "success",
              message: "添加成功",
            });
            this.InsertScenVisible2 = false;
            this.getComplexList();
            this.appliName2 = "";
            this.appliModel2 = "";
          } else {
            this.$message({
              type: "error",
              message: "添加失败",
            });
            return;
          }
        } else {
          let params = { id: this.appliIdl2, name: this.appliName2 };
          let res = await UpdateComplexcraftName(params);
          if (res.Code) {
            this.$message({
              type: "success",
              message: "编辑成功",
            });
            this.InsertScenVisible2 = false;
            this.getComplexList();
            this.appliName2 = "";
            this.appliModel2 = "";
          } else {
            this.$message({
              type: "error",
              message: "编辑失败",
            });
            return;
          }
        }
      }
    },
    imgsort(type) {
      this.type = type;
      if (type == "add") {
        this.FileFrom.fileListImg.forEach((e, i) => {
          this.$set(e, "sortnum", i + 1);
        });
        this.sortImgs = this.FileFrom.fileListImg;
      } else if (type == "update") {
        this.EfileListImg.forEach((e, i) => {
          this.$set(e, "sortnum", i + 1);
        });
        this.sortImgs = this.EfileListImg;
      }
      this.DialogVisibleSort = true;
    },
    submitMove() {
      this.sortImgs.sort((a, b) => {
        return a.sortnum - b.sortnum;
      });
      if (this.type == "add") {
        this.FileFrom.fileListImg = this.sortImgs;
      } else if (this.type == "update") {
        this.EfileListImg = this.sortImgs;
      }
      this.DialogVisibleSort = false;
    },
    handleRemove(file) {
      this.delUrl.push(file.url.replace(this.$store.state.baseUrl, ""));
    },
    handlePreview(file) {},
    //获取复杂工艺信息列表
    getComplexList(val) {
      let newids = [];
      if (val) {
        this.zNodes.forEach((element) => {
          if (element.cpcf01 === val) {
            this.addfid = "";
            this.$set(this, "addfid", element);
            if (element.cpcf04 !== 0) {
              newids.push(element.cpcf01);
            }
            this.zNodes.forEach((element2) => {
              if (element2.cpcf08 === element.cpcf01) {
                newids.push(element2.cpcf01);
              }
            });
          }
        });
      }
      if (val == "all" || val == undefined) {
        this.mlids = "";
      } else if (newids.length > 0) {
        this.mlids = newids.join(",");
      } else {
        this.mlids = val;
      }
      let params = {
        seachword: "",
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        pid: this.$store.state.xid,
        ids: this.mlids,
      };
      GetComplexcraftsList(params).then((res) => {
        res.Data.list.forEach((element) => {
          if (element.cpcf05 != "" && element.cpcf05 != null) {
            var pics = element.cpcf05.split(",");
            element.cpcf05 = [];
            pics.forEach((v, i) => {
              i == 0 ? (element.cpcf10 = v) : "";
              element.cpcf05.push(this.$store.state.baseUrl + v);
            });
          }
        });
        if (this.mlids == "") {
          this.zNodes = res.Data.list.filter((ele) => {
            let bol = false;
            this.tableData = [];
            res.Data.list.forEach((ele2) => {
              if (ele.cpcf01 == ele2.cpcf08 || ele2.cpcf08 == 0) {
                bol = true;
              } else {
                this.tableData.push(ele);
              }
            });
            return bol;
          });
        }
        this.tableData = res.Data.list.filter((e) => {
          let bol = false;
          if (e.cpcf04 === 0) {
            bol = false;
          } else {
            bol = true;
          }
          return bol;
        });
        this.total = res.Data.total;
      });
    },
    //删除复杂工艺
    async delComp(row) {
      if (row.pass) {
        let params = {
          id: parseInt(row.cpcf01.split(",")[0]),
        };
        let res = await DeleteComplexcraft(params);
        if (res.Code) {
          this.$message({
            type: "success",
            message: "移除成功!",
          });
          this.getComplexList();
        } else {
          this.$message({
            type: "error",
            message: "移除失败!",
          });
        }
      } else {
        this.$confirm("确定删除该项?", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            let params = {
              id: row,
            };
            let res = await DeleteComplexcraft(params);
            if (res.Code) {
              this.$message({
                type: "success",
                message: "移除成功!",
              });
              this.getComplexList();
            } else {
              this.$message({
                type: "error",
                message: "移除失败!",
              });
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }
    },
    //上传确定按钮
    InsertWorkmandeter(uploadForm) {
      this.UploadFileFrom = new FormData();
      this.$refs[uploadForm].validate((v) => {
        if (v) {
          this.UploadFileFrom.append("pid", this.$store.state.xid);
          this.UploadFileFrom.append("title", this.FileFrom.WorkmanName);
          this.UploadFileFrom.append(
            "type",
            parseInt(this.FileFrom.WorkmanType)
          );
          this.UploadFileFrom.append("describe", this.FileFrom.WorkmanDesc);
          //文件处理
          switch (parseInt(this.FileFrom.WorkmanType)) {
            case 1:
              this.FileFrom.fileListImg.forEach((file) => {
                this.UploadFileFrom.append("files", file.raw);
              });
              break;
            case 2:
              this.FileFrom.fileListVideo.forEach((file) => {
                this.UploadFileFrom.append("files", file.raw);
              });
              break;
            default:
              break;
          }
          if (this.addfid) {
            this.UploadFileFrom.append("fid", this.addfid.cpcf01);
          } else {
            this.UploadFileFrom.append("fid", 0);
          }

          this.UploadFileFrom.append("sort", 0);
          this.UploadFileFrom.append("ids", "");
          InsertComplexcraft(this.UploadFileFrom).then((res) => {
            if (res.Code) {
              this.$message({
                type: "success",
                message: "上传成功!",
              });
              this.InserworkmansVisible = false;
              this.getComplexList();
              this.FileFrom = {
                WorkmanName: "",
                WorkmanType: "1",
                WorkmanDesc: "",
                fileListImg: [], //图片
                fileListVideo: [], //视频
              };
              this.delUrl = [];
              this.addfid = "";
            }
          });
        }
      });
    },
    //编辑复杂工艺
    EditComp(row) {
      this.EditworkmansVisible = true;
      this.EditFileFrom = JSON.parse(JSON.stringify(row));
      this.imageUrl = row.cpcf05;
      this.EfileListImg = [];
      if (row.cpcf05) {
        row.cpcf05.forEach((element) => {
          this.EfileListImg.push({
            name: element.substr(element.lastIndexOf("/") + 1, element.length),
            url: element,
          });
        });
      }
      // if (this.EditFileFrom.cpcf04 == 2) {
      //   this.delUrl.push(row.cpcf05[0].replace(this.$store.state.baseUrl, ""));
      // }
    },
    //修改确定按钮
    EditWorkmandeter(EdituploadForm) {
      this.$refs[EdituploadForm].validate((v) => {
        if (v) {
          this.EUploadFileFrom = new FormData();
          this.EUploadFileFrom.append("id", this.EditFileFrom.cpcf01);
          this.EUploadFileFrom.append("title", this.EditFileFrom.cpcf03);
          this.EUploadFileFrom.append("type", this.EditFileFrom.cpcf04);
          this.EUploadFileFrom.append("describe", this.EditFileFrom.cpcf06);
          this.EUploadFileFrom.append("fid", this.EditFileFrom.cpcf08);
          this.EUploadFileFrom.append("sort", this.EditFileFrom.cpcf09);
          //文件处理
          switch (this.EditFileFrom.cpcf04) {
            case 1:
              this.EfileListImg.forEach((file) => {
                if (file.raw) {
                  this.EUploadFileFrom.append("files", file.raw);
                }
              });
              break;
            case 2:
              this.EfileListVideo.forEach((file) => {
                this.EUploadFileFrom.append("files", file.raw);
              });
              break;
            default:
              break;
          }
          this.EUploadFileFrom.append("delurl", this.delUrl.join(","));
          UpdateComplexcraft(this.EUploadFileFrom).then((res) => {
            if (res.Code) {
              this.$message({
                type: "success",
                message: "修改成功!",
              });
              this.EfileListImg = [];
              this.delUrl = [];
              this.EditworkmansVisible = false;
              this.getComplexList();
            }
          });
        }
      });
    },
    //添加、修改上传图片
    handleChange(file, fileList) {
      if (this.InserworkmansVisible) {
        this.FileFrom.fileListImg = fileList;
      } else if (this.EditworkmansVisible) {
        this.EfileListImg = fileList;
      } else {
        this.SfileListImg = fileList;
      }
    },
    //添加、修改上传视频
    handleChangeVideo(file, fileList) {
      if (this.InserworkmansVisible) {
        this.FileFrom.fileListVideo = fileList.slice(-3);
      } else if (this.EditworkmansVisible) {
        this.EfileListVideo = fileList.slice(-3);
      } else {
        this.SfileListVideo = fileList.slice(-3);
      }
    },
    //切换视频
    switchVid(row) {
      this.ResetDialogVisible = true;
      this.switchFileFrom = row;
      // this.delUrl.push(row.cpcf05[0].replace(this.$store.state.baseUrl, ""));
    },
    //切换视频的上传确定按钮
    resetSubmit() {
      this.UploadFileFrom2 = new FormData();
      this.UploadFileFrom2.append("id", this.switchFileFrom.cpcf01);
      this.UploadFileFrom2.append("title", this.switchFileFrom.cpcf03);
      this.UploadFileFrom2.append("type", this.switchFileFrom.cpcf04);
      this.UploadFileFrom2.append("describe", this.switchFileFrom.cpcf06);
      this.UploadFileFrom2.append("fid", this.switchFileFrom.cpcf08);
      this.UploadFileFrom2.append("sort", this.switchFileFrom.cpcf09);
      //文件处理
      switch (this.switchFileFrom.cpcf04) {
        case 1:
          this.SfileListImg.forEach((file) => {
            this.UploadFileFrom2.append("files", file.raw);
          });
          break;
        case 2:
          this.SfileListVideo.forEach((file) => {
            this.UploadFileFrom2.append("files", file.raw);
          });
          break;
        default:
          break;
      }
      this.UploadFileFrom2.append("delurl", this.delUrl.join(","));
      UpdateComplexcraft(this.UploadFileFrom2).then((res) => {
        if (res.Code) {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.SfileListImg = [];
          this.SfileListVideo = [];
          this.delUrl = [];
          this.ResetDialogVisible = false;
          this.getComplexList();
        }
      });
    },
    //条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getComplexList();
    },
    //页数
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getComplexList();
    },
    //打开图片预览
    open(row) {
      var srcimg = this.$store.state.baseUrl + row.cpcf05;
      this.srcList.push(srcimg);
    },
  },
  created() {
    this.getComplexList();
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
/deep/ .headCard .el-card__header {
  padding: 18px 0px;
  border: none;
}

/deep/ .contentCard .el-card__header {
  padding: 8px 0px;
}

.contentCard .el-card {
  display: inline-block;
  margin-top: 20px;
  margin-left: 1.2%;
}

// .contentCard {
//   margin-left: -1.2%;
// }

.col-Img {
  .imgage {
    width: 100%;
    height: 238px;
    border-radius: 10px;
  }

  .delete-img {
    width: 58.33333%;
    display: none;

    .dangBut {
      position: relative;
      left: 170px;
      top: 100px;
    }
  }

  &:hover {
    .delete-img {
      display: block;
      height: 235px;
      position: absolute;
      top: -0px;
      border-radius: 8px;
      background: rgba(59, 60, 61, 0.5);
      cursor: pointer;
    }
  }
}

.col-video {
  .video {
    width: 100%;
    height: 235px;
    border-radius: 8px;
  }

  .delete-img {
    width: 100%;
    display: none;

    .dangBut {
      position: relative;
      left: 170px;
      top: 100px;
    }
  }

  &:hover {
    .delete-img {
      display: block;
      height: 240px;
      position: absolute;
      top: 0px;
      border-radius: 8px;
      background: rgba(59, 60, 61, 0.5);
      cursor: pointer;
    }
  }
}

.mytt {
  font-size: 14px;
  width: 16vw;
  height: 240px;
  overflow: auto;
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-line;
}

/deep/.el-dialog {
  border-radius: 10px;
}
</style>
